import { render } from "./NcrmNotificationNavItem.vue?vue&type=template&id=1ed890da&scoped=true"
import script from "./NcrmNotificationNavItem.vue?vue&type=script&lang=js"
export * from "./NcrmNotificationNavItem.vue?vue&type=script&lang=js"

import "./NcrmNotificationNavItem.vue?vue&type=style&index=0&id=1ed890da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed890da"]])

export default __exports__